function w(r) {
  var o = r.align, t = r.alignVertical, e = r.textRotation, l = r.indent, n = r.wrap, d = r.fontFamily, i = r.fontSize, a = r.fontWeight, f = r.fontStyle, B = r.color, y = r.backgroundColor, S = r.borderColor, g = r.borderStyle, C = r.leftBorderColor, b = r.leftBorderStyle, c = r.rightBorderColor, p = r.rightBorderStyle, u = r.topBorderColor, h = r.topBorderStyle, m = r.bottomBorderColor, v = r.bottomBorderStyle;
  if (o || t || e || l || n || d || i || a || f || B || y || S || g || C || b || c || p || u || h || m || v)
    return x({
      align: o,
      alignVertical: t,
      textRotation: e,
      indent: l,
      wrap: n,
      fontFamily: d,
      fontSize: i,
      fontWeight: a,
      fontStyle: f,
      color: B,
      backgroundColor: y,
      borderColor: S,
      borderStyle: g,
      leftBorderColor: C,
      leftBorderStyle: b,
      rightBorderColor: c,
      rightBorderStyle: p,
      topBorderColor: u,
      topBorderStyle: h,
      bottomBorderColor: m,
      bottomBorderStyle: v
    });
}
function x(r) {
  var o = {};
  for (var t in r)
    r[t] !== void 0 && (o[t] = r[t]);
  return o;
}
export {
  w as default
};
//# sourceMappingURL=index.es518.js.map
